//#region src/fp/transform.ts
/**
* Normalize an unknown caught value into an Error instance.
*
* If already an Error, returns it as-is. Otherwise wraps via `new Error(String(value))`.
*
* @param value - The unknown value to normalize.
* @returns An Error instance.
*/
function toError(value) {
	if (value instanceof Error) return value;
	return new Error(String(value));
}
//#endregion
//#region src/fp/result.ts
function ok(value) {
	return [null, value];
}
/**
* Construct a failure Result tuple.
*
* Coerces any value to an `Error` via {@link toError} and returns `[Error, null]`.
* For domain-specific error types (e.g. `AuthError`, `IconsError`), use raw
* tuple literals instead: `[domainError, null] as const`.
*
* @param error - The error value (coerced to Error).
* @returns A Result tuple `[Error, null]`.
*/
function err(error) {
	return [toError(error), null];
}
//#endregion
export { ok as n, toError as r, err as t };

//# sourceMappingURL=result-D_NYcfr2.js.map